import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useOutsideClick } from '../../utils/UseOutsideClick';
import ModalBackdrop from '../../modal/ModalBackdrop';
import { DesktopSearchForm } from './desktop/DesktopSearchForm';
import { useSearch } from './use-search';
import { searchFormViewed } from './analytics';
import { animated, easings, useSpring, } from '@react-spring/web';
import get from "lodash/get";

const duration = 250;

export const SearchBar = (props) => {
  const containerRef = useRef();
  const {
    closeSearchWidgetFn,
    displaySearchWidget
  } = useSearch();
  const [hasRested, setHasRested] = useState(false);
  const [transitionState, setTransitionState] = useState('');

  useOutsideClick(containerRef, (e) => {
    const isMenu =
        e.target.closest('[class*="menu"]')
        || e.target.classList.contains('menu');
    if (hasRested && !isMenu) {
      closeSearchWidgetFn();
    }
  });

  useEffect(() => {
    if (hasRested) {
      searchFormViewed({
        location: props.searchLocation,
        activity: props.searchActivity
      });
    }
  }, [hasRested]);

  const transitions = useSpring({
    y: displaySearchWidget ? '100%' : '0%',
    onRest: {
      y: (yAnimation) => {
        if ('100%' === yAnimation.value) {
          setHasRested(true);
        } else {
          setHasRested(false);

          // Keeps track of which position the search bar is in
          // This track if the search bar fully closes from the open position
          if ('0%' === yAnimation.value) {
            setTransitionState('exited');
          }
        }
      }
    },
    onStart: {
      y: (yAnimation) => {
        // This tracks if the search bar is about to open from the closed positions
        const toValue = get(yAnimation, 'value.animation.to');
        if ('100%' === toValue) {
          setTransitionState('entering');
        }
      }
    },
    config: {
      duration,
      easing: easings.easeOutCirc
    }
  });

  return (
    <ModalBackdrop show={displaySearchWidget} duration={duration}>
      <animated.div
        className="SlideBar search-bar-inner-container"
        style={{
          transform: transitions.y.interpolate(value => `translateY(${value})`)
        }}
      >
        {
          // If the search bar is in the closed position we want to unmount the component
          'exited' !== transitionState &&
            <div ref={containerRef}>
              <DesktopSearchForm />
            </div>
        }
      </animated.div>
    </ModalBackdrop>
  );
};

SearchBar.propTypes = {
  props: PropTypes.object
};
